import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  return {
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '20px',
      minHeight: '40px'
    },
    hide: {
      visibility: 'hidden',
    }, 
    flex: {
      display: 'flex',
      alignItems: 'center',
      '&.flex-j-e': {
        justifyContent: 'end',
      },
    },
    section: {
      marginBottom: '32px',
    },
    clean: {
      fontSize: '2.4rem',
      color: colors.color4,
      padding: '6px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
  }
}

export { useStyles }
